import './App.css';
import { useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Route, Routes } from 'react-router-dom';

import AppLayout from '@/AppLayout';
import { queryConfig } from '@/api/react-query.config';
import { appRoutes } from '@/routes';

import Layout from '@/components/Layout';

function App() {
  // State
  const [queryClient] = useState(() => {
    return new QueryClient({
      defaultOptions: queryConfig,
    });
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route element={<Layout />}>
            {appRoutes.map((route) => (
              <Route
                element={route.element}
                key={route.path}
                path={route.path}
              />
            ))}
          </Route>
        </Route>
      </Routes>
    </QueryClientProvider>
  );
}

export default App;
